import { DatasetListResponse } from "datasets/types/interfaces/datasetListItem";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

const SORT_FIELDS = {
  title: "title",
  createdAt: "created_at",
  updatedAt: "updated_at",
} as const;

interface UseDatasetOptions {
  offset?: number;
  limit?: number;
  sortBy?: keyof typeof SORT_FIELDS;
  sortOrder?: "asc" | "desc";
  /** When false, nothing is fetched and `data` stays undefined. */
  enabled?: boolean;
}

const useDatasets = (options: UseDatasetOptions = {}) => {
  // TODO: Adjust limit when pagination properly implemented
  const {
    offset = 0,
    limit = 1000,
    sortBy = "updatedAt",
    sortOrder = "desc",
    enabled = true,
  } = options;
  const sort = `${sortOrder === "desc" ? "-" : ""}${SORT_FIELDS[sortBy]}`;

  const url = `${VITE_CATALOG_API}/v1/datasets?offset=${offset}&limit=${limit}&sort=${sort}&fields=TABLE_COUNT&fields=TABLE_STATISTICS`;
  const { data, error, isLoading } = useFetcher<DatasetListResponse>(enabled ? url : null);
  return { data: data?.items, error, isLoading };
};

export default useDatasets;
